import { usePermissions } from '@/contexts/PermissionsContext';
import { useInboundUnreadCounts } from '@/hooks/useInboundEmails';
import { savRequestsService } from '@/services/savRequestsService';
import { useQuery } from '@tanstack/react-query';

export const SAV_REQUESTS_UNREAD_COUNT_KEY = ['sav-requests-unread-count'] as const;

/**
 * Pastille de l'icône SAV : nouvelles demandes du site (non lues, hors spam) + demandes ayant une réponse du client non lue,
 * actualisé toutes les 60 s (pas de Realtime).
 * Désactivé sans la permission 'sav_requests' : aucune requête pour les autres utilisateurs.
 * En cas d'erreur : valeur indéfinie (le badge reste masqué), nouvel essai à l'intervalle suivant.
 */
export function useSavRequestsUnreadCount() {
  const { hasPermission, isLoading } = usePermissions();
  const allowed = !isLoading && hasPermission('sav_requests');

  const query = useQuery({
    queryKey: SAV_REQUESTS_UNREAD_COUNT_KEY,
    queryFn: () => savRequestsService.getUnreadCount(),
    enabled: allowed,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  const { counts } = useInboundUnreadCounts();
  const withReply = counts ? Object.keys(counts.sav).length : 0;
  const count =
    allowed && (query.data !== undefined || counts !== undefined)
      ? (query.data ?? 0) + withReply
      : undefined;

  return { allowed, count, isError: query.isError };
}
